var map = {
	"./af.json": 23410,
	"./am.json": 33126,
	"./ar.json": 91126,
	"./az.json": 77867,
	"./be.json": 48835,
	"./bg.json": 97493,
	"./bn.json": 70698,
	"./bs.json": 77716,
	"./ca.json": 81113,
	"./cs.json": 43842,
	"./cy.json": 70971,
	"./da.json": 80373,
	"./de.json": 60352,
	"./dv.json": 13053,
	"./el.json": 89313,
	"./en.json": 46698,
	"./es.json": 30218,
	"./et.json": 51197,
	"./eu.json": 68261,
	"./fa.json": 14704,
	"./fi.json": 26237,
	"./fr.json": 62833,
	"./gl.json": 21110,
	"./ha.json": 23166,
	"./he.json": 89476,
	"./hi.json": 29534,
	"./hr.json": 13223,
	"./hu.json": 70901,
	"./hy.json": 81541,
	"./id.json": 35690,
	"./is.json": 17046,
	"./it.json": 80858,
	"./ja.json": 9122,
	"./ka.json": 84001,
	"./kk.json": 33366,
	"./km.json": 69469,
	"./ko.json": 21694,
	"./ku.json": 84859,
	"./ky.json": 38818,
	"./lt.json": 98516,
	"./lv.json": 40614,
	"./mk.json": 65311,
	"./ml.json": 50933,
	"./mn.json": 7231,
	"./mr.json": 68648,
	"./ms.json": 7454,
	"./nb.json": 68958,
	"./nl.json": 62289,
	"./nn.json": 794,
	"./no.json": 43947,
	"./pl.json": 79082,
	"./ps.json": 58508,
	"./pt.json": 96352,
	"./ro.json": 10975,
	"./ru.json": 37038,
	"./sd.json": 88474,
	"./sk.json": 12102,
	"./sl.json": 96671,
	"./so.json": 63456,
	"./sq.json": 10884,
	"./sr.json": 89508,
	"./sv.json": 74094,
	"./sw.json": 72939,
	"./ta.json": 38218,
	"./tg.json": 77285,
	"./th.json": 25802,
	"./tr.json": 15048,
	"./tt.json": 90554,
	"./ug.json": 99154,
	"./uk.json": 6863,
	"./ur.json": 3924,
	"./uz.json": 49671,
	"./vi.json": 50894,
	"./zh.json": 99597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97905;